import { env } from '../../app/utils';
import { libHost } from '../../shared/constants/urls';
import { injectScript } from '../../shared/injectScript';

import delay from 'lodash/delay';
import { rgIDs } from '../../shared/constants/domIDs';
import {
  cssNamespace,
  isButton,
  isFixed,
  isRelative,
} from '../../shared/styles';
import { attachToNode, createFrame } from '../utils/builder';
import './styles.scss';
import { BaseMessenger, MessengerConfig } from '../messenger/base';

class RGMessengerV2 extends BaseMessenger {
  constructor() {
    super(rgIDs.messengerV2);
  }

  onShow() {
    if (this.element) {
      this.element.style.display = 'none';
    }
  }

  onHide() {}

  addClass(className: string) {
    this.element?.classList.add(className);
  }

  setPosition(position: 'left' | 'right') {
    this.addClass(position);
  }

  setRenderStyle(style: string) {
    const className = `${cssNamespace}${style}`;
    this.addClass(className);
  }

  setZIndex() {}

  async render(config: MessengerConfig): Promise<void> {
    this.config = config;

    try {
      this.element = await createFrame(this.elId);

      this.setRenderStyle(config.renderAs);

      if (isFixed(config.renderAs) || isButton(config.renderAs)) {
        this.setPosition(config.position);
        this.setMargins();
      }

      if (isRelative(config.renderAs) && this.element) {
        attachToNode(rgIDs.relativeNode, this.element);
      }

      await injectScript(`${libHost}/rg-messenger-v2-init.min.js`, '');
      window.RGMessengerV2Component.render(config, this.elId);

      await new Promise((resolve) => {
        delay(resolve, 1000);
      });
    } catch (error) {
      this.detachResponsiveMargins();
      throw error;
    }
  }

  unmount() {
    if (this.element?.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }

    this.detachResponsiveMargins();
  }
}

window.RGMessengerV2 = new RGMessengerV2();
